import React from 'react';

export const ProductSkeleton = () => {
    return (
        <div className="relative rounded-lg overflow-hidden bg-white shadow-soft animate-pulse">
            {/* Square image placeholder */}
            <div className="aspect-square bg-gradient-to-br from-surface-muted to-mekomit-50" />
            {/* Compact info section */}
            <div className="p-2.5 space-y-1.5">
                {/* Product name - 2 lines */}
                <div className="space-y-1">
                    <div className="h-3 rounded bg-surface-sunken w-full" />
                    <div className="h-3 rounded bg-surface-sunken w-3/4" />
                </div>
                {/* Price */}
                <div className="h-3.5 rounded bg-mekomit-100 w-1/4" />
                {/* Add to cart button */}
                <div className="h-7 bg-mekomit-100 rounded-md mt-1" />
            </div>
        </div>
    );
};

export default ProductSkeleton;